import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffAddEditIntegrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffAddEditIntegrationModalContainer" */
      './StaffAddEditIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
